import { Spinner, Typography } from "neetoui";
import { useTranslation } from "react-i18next";

import ProductLink from "./ProductLink";

const Content = ({ highlightedIndex, filteredApps, isLoading }) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Spinner />
      </div>
    );
  }

  return filteredApps?.length > 0 ? (
    <div className="neeto-molecules-product-switcher__grid">
      {filteredApps.map((app, index) => (
        <ProductLink
          key={app.name}
          {...app}
          data-highlighted-index={index}
          isHighlighted={index === highlightedIndex}
        />
      ))}
    </div>
  ) : (
    <Typography
      className="neeto-ui-text-center"
      data-testid="no-apps-found-title"
      style="body1"
    >
      {t("neetoMolecules.productSwitcher.noApps")}
    </Typography>
  );
};

export default Content;
